import { NdtStep } from "./helpers";

export default function() {
    return NdtStep('step4', 'Step 4: Do all participants have the same opportunity to select benefits under the plan?', {
        nextComponent() {
            let { step1, step2, step3, step4 } = this.answers;
            if([step1, step2, step3, step4].every(a => a === true)) return null;
            return 'step5';
        }
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step4.js